import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import './index.scss';
import '@/component/page';
import Header from '@/component/header';
import Footer from '@/component/footer';
import ButtonList from './buttonList';

const state = {
    freeList: [
        {
            name: '用户手册',
            link: '/autoinfo/manual-user.html',
            iconUrl:
                'https://p.ampmake.com/fed/image/png/e64fcccc4d1b48f0078a6ad1facdd3d7.png'
        },
        {
            name: '认证信息',
            link: '/autoinfo/certification.html',
            iconUrl:
                'https://p.ampmake.com/fed/image/png/7546288fdd09cfcd3f8fda1295576d01.png'
        },
        {
            name: '环保信息',
            link: '/autoinfo/environmental-information.html',
            iconUrl:
                'https://p.ampmake.com/fed/image/png/9686acdd5802ef6f7f1bed7a352f9783.png'
        },
        {
            name: '召回信息',
            link: '/autoinfo/recall.html',
            iconUrl:
                'https://p.ampmake.com/fed/image/png/431887ed541b5e335f6daef412acfeef.png'
        },
        {
            name: '通用信息',
            link: '/autoinfo/information.html',
            iconUrl:
                'https://p.ampmake.com/fed/image/png/287021370081647dc3d8343a4efff4e1.png'
        }
    ],
    payList: [
        {
            name: '维修手册',
            link: '/autoinfo/maintain.html',
            iconUrl:
                'https://p.ampmake.com/fed/image/png/625648d7b9d15506b01dad3689e97895.png'
        },
        {
            name: '零件目录',
            link: '/autoinfo/material.html',
            iconUrl:
                'https://p.ampmake.com/fed/image/png/8cf838f527ee50c520181448e0c90a98.png'
        }
    ]
};

class App extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = state;
    }

    public render() {
        return (
            <>
                <Header />
                <div className="chj-content">
                    <div className="pic" />
                    <div className="main">
                        <ButtonList type={2} list={this.state.payList} />
                        <ButtonList type={1} list={this.state.freeList} />
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

ReactDOM.render(<App />, document.getElementById('app'));
